<template>
  <v-container fluid>
    <!-- Filters card (unchanged) -->
    <template>
      <v-card class="mt-4">
        <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Αναζήτηση"
                single-line
                clearable
                hide-details
              ></v-text-field>
            </v-col>
            <v-col>
              <v-select
                :items="partCategories"
                label="Κατηγορία Ανταλλακτικού"
                v-model="category"
                :hint="`Cat-ID: ${category}`"
                persistent-hint
                item-text="Description"
                item-value="CatId"
                clearable
              ></v-select>
            </v-col>
            <v-col>
              <v-combobox
                v-model="manf"
                :items="uniqueManufacturers"
                prepend-icon="mdi-factory"
                label="Κατασκευαστής"
                chips
                multiple
                clearable
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(manf, item)"
                  >
                    <strong>{{ item }}</strong>&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="2">
              <v-switch v-model="inStock" label="Σε απόθεμα"></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>

    <template>
      <v-card class="ma-0 mt-4" :loading="loading">
        <v-card-title>
          <h1 class="mr-2 subheading grey--text">Λίστα Παραγγελιών</h1>
          <v-spacer/>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="parts"
          :search="search"
          item-key="Id"
          class="elevation-1"
          :loading="loading"
          :expanded.sync="expanded"
          sort-desc
          sort-by="Id"
          show-group-by
          loading-text="Loading... Please wait"
        >
          <template v-slot:item.actions="{ item }">
            <v-btn icon small :to="{name: 'order-info', params: {id: item.Id}}">
              <v-icon>mdi-dolly</v-icon>
            </v-btn>
            <v-btn icon small :to="{name: 'part-info', params: {id: item.PartId}}">
              <v-icon>mdi-information-variant</v-icon>
            </v-btn>
            <v-btn v-if="item.Invoice" icon small :to="{name: 'distributor-order-checkin', params: {invoiceId: item.Invoice.Id}}">
              <v-icon>mdi-file-document</v-icon>
            </v-btn>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="primary" v-bind="attrs" v-on="on" @click.stop="openPreorderDialog(item)">
                  <v-icon>mdi-cart-plus</v-icon>
                </v-btn>
              </template>
              <span>Νέα Προπαραγγελία</span>
            </v-tooltip>
          </template>

          <template v-slot:item.RetailPrice="{ item }">
            {{ tocurr(item.RetailPrice*(1-item.Discount)) }}
          </template>
          <template v-slot:item.Timestamp="{ item }">
            {{ $fmtDate(item.Timestamp) }}
          </template>
          <template v-slot:item.SuggestedPrice="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">{{ $tocurr(item.SuggestedPrice) }}</span>
              </template>
              <span>{{((item.SuggestedPrice/item.PartCost-1)*100).toFixed(0)}}% - {{$tocurr(item.SuggestedPrice-item.PartCost)}}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.CategoryId="{ item }">
            {{ partCategories.find(i => i.CatId === item.CategoryId).Description }}
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <tr>
              <td :colspan="headers.length">
                More info about {{ item.FmSku }}
                <p>Related invoices:</p>
              </td>
            </tr>
            <v-list-item v-for="i in item.Orders" :key="i.Id">
              <v-list-item-content>
                <v-list-item-title>
                  {{ i.Id }}
                  <v-btn icon :to="'/invoice/details/'+i.Id">
                    <v-icon>mdi-git</v-icon>
                  </v-btn>
                </v-list-item-title>
                {{ i.Manufacturer }} - {{ i.ManufacturerSku }} - {{ i.SupplierSku }}
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-data-table>
      </v-card>
    </template>

    <!-- Preorder dialog -->
    <distributor-order-preorder-dialog
      v-model="preorderDialogOpen"
      :order="activeOrder"
      :vehicles="vehicles"
      :technicians="technicians"
      :supplier="supplier"
      :repairs-for-vehicle="repairsForVehicle"
      :loading-vehicles="loadingVehicles"
      :loading-repairs="loadingRepairs"
      :partCategories="partCategories"
      :statuses="statuses"
      @fetch-repairs-for-vehicle="fetchRepairsForVehicle"
      @save="savePreorderFromOrder"
      @close="preorderDialogOpen = false"
      @validation-error="notifyError"
    />

<v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout" top right>
  {{ snackbar.message }}
</v-snackbar>

  </v-container>
</template>

<script>
import DistributorOrderPreorderDialog from '@/components/DistributorOrderPreorderDialog.vue';

export default {
  name: 'DistributorOrders',
  components: { DistributorOrderPreorderDialog },
  data() {
    return {
      menu: false,
      expanded: [],
      checkoutdialog: false,
      partQty: 0,
      partTechId: 1,
      loading: true,
      newPart: { CategoryId: 0 },
      partCategories: [],
      search: '',
      inStock: false,
      parts: [],
      manf: [],
      category: null,
      supplier: null,
      uniqueSuppliers: [],
      vehicles: [],
      repairsForVehicle: [],
      technicians: [],
      loadingVehicles: false,
      loadingSuppliers: false,
      loadingRepairs: false,
      snackbar: {
        visible: false,
        message: '',
        color: 'success', // 'success' | 'error' | 'info' | 'warning'
        timeout: 4000 
      },
      preorderDialogOpen: false,
      activeOrder: null,
      statuses: [
        { Id: -2, Description: 'Ζήτηση' },
        { Id: -1, Description: 'Παραγγελία' },
        { Id: 0, Description: 'Παραλαβή' },
        { Id: 1, Description: 'Ολοκληρωμένη' },
      ],

      rules: {
        partId: value => {
          const pattern = /^\d{1,5}$/;
          return pattern.test(value) || 'Invalid Part-ID.';
        },
      },
      headers: [
        { text: 'Α/Α', align: 'start', value: 'Id', width: '5%' },
        { text: 'Ημ/νια', value: 'Timestamp', align: 'start' },
        { text: 'Κωδικός', align: 'start', value: 'FmSku', width: '5%' },
        { text: 'Id', align: 'start', value: 'PartId', width: '5%' },
        { text: 'Κωδικός Προμηθευτή', align: 'start', value: 'SupplierSku', width: '5%' },
        { text: 'Κωδικός Κατασκευαστή', align: 'start', value: 'ManufacturerSku', width: '5%' },
        {
          text: 'Κατηγορία', value: 'CategoryId', groupable: false, width: '5%',
          filter: (value) => { if (!this.category) return true; return value == this.category; },
        },
        {
          text: 'Κατασκευαστής', value: 'Manufacturer', groupable: true, width: '20%',
          filter: (value) => { if (this.manf.length == 0) return true; return this.manf.includes(value); }
        },
        { text: 'Περιγραφή', value: 'Description', groupable: false, width: '50%' },
        { text: 'Τιμή χονδρικής', value: 'RetailPrice', align: 'end', groupable: false },
        { text: 'Τιμή λιανικής', value: 'SuggestedPrice', align: 'end', groupable: false },
        {
          text: 'Απόθεμα', value: 'StockQty', align: 'end', groupable: false,
          filter: (value) => { if (!this.inStock) return true; return value > 0; },
        },
        { text: 'Actions', value: 'actions', groupable: false, width: '25%' },
        { text: '', value: 'data-table-expand' },
      ],
    };
  },
  computed: {
    partsCost () {
      return this.parts.reduce((a, b) => a + (b.StockCost || 0), 0);
    },
    partsSaleValue () {
      return this.parts.reduce((a, b) => a + (b.SaleValue || 0), 0);
    },
    isAdmin() {
      if (!this.$store.state.authentication.user) return false;
      return this.$store.state.authentication.user.scopes.includes('income');
    },
    uniqueManufacturers () {
      return this.uniq(this.parts, 'Manufacturer');
    },
  },
  async created() {
    try {
      this.loading = true;
      const response = await this.$api.get(`/inventory/supplier/${this.$route.params.id}/orders`);
      this.parts = response.data;
      const catresponse = await this.$api.get('/inventory/parts/categories');
      this.partCategories = catresponse.data;
      const resp = await this.$api.get(`/suppliers/info/${this.$route.params.id}`);
      this.supplier = resp.data;
      // preload auxiliary datasets used by the dialog
      await Promise.all([
        this.fetchTechnicians(),
        this.fetchVehicles(), // optional preload
      ]);

      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  },
  methods: {
    // Existing methods unchanged except added ones below
    tocurr(value) {
      return new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(value.toFixed(2));
    },
    uniqSup(items) {
      let uniques = [];
      let itemsFound = {};
      let supp = null;
      for (let val of items) {
        supp = val['Invoice']['Supplier'];
        if (itemsFound[supp.Id]) continue;
        uniques.push(supp);
        itemsFound[supp.Id] = true;
      }
      return uniques;
    },
    uniq(items, key) {
      let uniques = [];
      let itemsFound = {};
      for (let val of items) {
        if (itemsFound[val[key]]) continue;
        uniques.push(val[key]);
        itemsFound[val[key]] = true;
      }
      return uniques;
    },
    remove(obj, item) {
      obj.splice(obj.indexOf(item), 1);
      obj.manf = [...obj];
    },

    // NEW: dialog wiring
    openPreorderDialog(orderRow) {
      this.activeOrder = orderRow;
      this.preorderDialogOpen = true;
      // Optionally fetch repairs for a preselected vehicle if you have such relation
    },
    async savePreorderFromOrder(payload) {
      try {
        // POST to preorders create endpoint
        const resp = await this.$api.post('/inventory/preorders/create', payload);
        console.log(resp);
        if (resp && (resp.status === 201 || resp.status === 200)) {
          this.snackbar.message = 'Η προπαραγγελία δημιουργήθηκε';
          this.snackbar.color = 'success';
          this.snackbar.visible = true;
          this.preorderDialogOpen = false;
        } else {
          throw new Error('Αποτυχία δημιουργίας προπαραγγελίας');
        }
      } catch (e) {
        console.error(e);
        this.notifyError(e.message || 'Σφάλμα δημιουργίας προπαραγγελίας');
      }
    },
    notifyError(msg) {
      this.snackbar.message = msg || 'Σφάλμα';
      this.snackbar.color = 'error';
      this.snackbar.visible = true;
    },

    // Data providers used in dialog
    async fetchTechnicians() {
      try {
        const res = await this.$api.get('/repairs/technicians/');
        this.technicians = res.data || [];
      } catch (e) { console.error(e); }
    },
    async fetchVehicles() {
      try {
        this.loadingVehicles = true;
        const res = await this.$api.get('/repairs/vehicles'); // adjust endpoint as needed
        this.vehicles = res.data || [];
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingVehicles = false;
      }
    },
    async fetchRepairsForVehicle(vehicleId) {
      if (!vehicleId) { this.repairsForVehicle = []; return; }
      try {
        this.loadingRepairs = true;
        const res = await this.$api.get(`/repairs?vehicleId=${vehicleId}&limit=50`);
        this.repairsForVehicle = (res.data || []).map(r => ({
          ...r,
          label: `${r.Id} — ${this.$fmtDate ? this.$fmtDate(r.Timestamp) : r.Timestamp}`,
        }));
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingRepairs = false;
      }
    },
  },
};
</script>